import { CustomAlertComponent } from './../../components/custom-alert/custom-alert.component';
import { ErrorMonitoringService } from 'src/app/services/error-monitoring/error-monitoring.service';
import { Component, OnInit, NgZone, Input } from '@angular/core';
import { ModalController, NavParams, AlertController } from '@ionic/angular';
import { HelperService } from 'src/app/services/helper/helper.service';
import { ServiceService } from 'src/app/services/service/service.service';

declare var google: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})
export class MapPage implements OnInit {
  /**
   * librería de places-api de google maps https://developers.google.com/places/web-service/intro
   * https://developers.google.com/maps/documentation/distance-matrix
   * https://developers.google.com/maps/documentation/geocoding/start
   *
   */
  private map: any;
  /** contiene el circulo que se dibuja con el rango */
  // private circle: any;
  /** contiene los bounds del mapa */
  private bounds: any;
  /** indica el valor del rango */
  private range = 1500;
  /** instancia del servicio autocompletar de google maps */
  private autocompleteMap: any;
  /** Lugares en el mapa */
  private mapsPlaces: any;
  /** Token de sesión */
  private sessionToken: any = null;
  /** Número de paso 0=Lista, 1=Mapa */
  public stepNumber = 0;
  /** Ubicaciones guardadas del usuario */
  public userLocations = [];
  /** Indicador de nueva ubicación seleccionada */
  public newUserLocationSelected: boolean;
  /** Cuadro de búsqueda */
  public searchingAddress = '';
  /** Lista de las sugerencias del servicio autocompletar de google maps. */
  public suggestList = [];
  /** Tamaño auto-adaptativo de la pantalla */
  public heightMap: number;
  /** Identificador del lugar actual */
  public placeIdActual: string;
  /** Objeto de ubicación para transporte */
  public location: {
    title: string,
    address: string,
    addressComplement: string,
    lat: number,
    lng: number,
    user: string,
  };
  /* Indica si se esta guardando la ubicación */
  savingLocation = false;

  /** Opciones de mapa por defecto */
  private mapOptions = {
    center: { lat: 0, lng: 0 },
    zoom: 17,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: true
  };

  /** Elemento de entrada conteniendo el usuario */
  @Input() user: any;
  /** indica si se muestra el range de distancia */
  @Input() showRange = false;
  /** indica si se debe obtener o no la posición actual */
  @Input() obtainPosition = true;

  constructor(
    private modalController: ModalController,
    private helperService: HelperService,
    public navParams: NavParams,
    private zone: NgZone,
    private servicesService: ServiceService,
    private errorMonitoringService: ErrorMonitoringService
  ) {
    // Crea una instancia del servicio autocompletar de google maps
    /* this.autocompleteMap = new google.maps.places.AutocompleteService(); */
  }

  ngOnInit() {
    if (this.user) {
      // obtiene las direcciones del usuario
      this.servicesService.getUserLocations(this.user.uid).subscribe(locations => {
        this.userLocations = locations;
      }, error => {
        return this.errorMonitoringService.sendError(error, 'getUserLocations');
      });
    }
    /* this.getCurrentPosition(); */
  }

  /* Cuando selecciona añadir dirección */
  addLocation() {
    this.location = {
      title: '',
      address: '',
      addressComplement: '',
      lat: null,
      lng: null,
      user: this.user.uid
    };
    this.newUserLocationSelected = true;
    this.stepNumber = 1;
  }

  /** obtiene la posición actual y carga el mapa en esa posición */
  async getCurrentPosition() {
    // Evalúa si el navegador no soporta la geolocalización y emite el mensaje de alerta
    if (!navigator.geolocation) {
      this.helperService.presentMessageAlert('Mensaje', 'Tu navegador no soporta geolocalización');
      return console.log('Geolocation is not supported for this Browser/OS.');
    }

    /** constante para Temporizador de obtener la ubicación */
    const nudgeTimeoutId = setTimeout(() => {
      /* this.helperService.presentMessageAlert(
        'Posición no disponible',
        'Usaremos una ubicación cercana, puedes buscar tu ubicación en la parte superior'
      ); */
    }, 3000);

    /** Constante cuando el proceso de obtener una dirección es exitoso */
    const geoSuccess = (position) => {
      // No se mostrará ningún banner o advertencia, porque se logro obtener la posición
      clearTimeout(nudgeTimeoutId);
      // Asignación de valores a variable local
      this.location = {
        title: '',
        address: '',
        addressComplement: '',
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        user: this.user.uid
      };
      this.getAddress();
      this.loadMap();
    };

    /** Constante cuando se presenta un error al obtener la ubicación actual */
    const geoError = (error) => {
      clearTimeout(nudgeTimeoutId);
      // Diferentes tipos de error
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.errorMonitoringService.sendError('PERMISSION DENIED', 'getCurrentPosition');
          this.helperService.presentMessageAlert('No tenemos permiso', 'Danos permiso a la ubicación para mejorar los resultados');
          break;
        case error.POSITION_UNAVAILABLE:
          this.errorMonitoringService.sendError('POSITION UNAVAILABLE', 'getCurrentPosition');
          /* this.helperService.presentMessageAlert(
            'Posición no disponible',
            'Usaremos una ubicación cercana, puedes buscar tu ubicación en la parte superior'
          ); */
          break;
        case error.TIMEOUT:
          this.errorMonitoringService.sendError('TIMEOUT', 'getCurrentPosition');
          /* this.helperService.presentMessageAlert(
            'Posición no disponible',
            'Usaremos una ubicación cercana, puedes buscar tu ubicación en la parte superior'
          ); */
          break;
        default:
          this.errorMonitoringService.sendError(error, 'getCurrentPosition');
          /* this.helperService.presentMessageAlert(
            'Posición no disponible',
            'Usaremos una ubicación cercana, puedes buscar tu ubicación en la parte superior'
          ); */
          break;
      }
      this.location = {
        title: '',
        address: '',
        addressComplement: '',
        lat: 4.6830546,
        lng: -74.0545839,
        user: this.user.uid
      };
      this.loadMap();
    };

    /** Ejecuta la acción de obtener la ubicación */
    await navigator.geolocation.getCurrentPosition(geoSuccess, geoError, { timeout: 10 * 1000 });
  }

  /** Obtiene la dirección y la escribe en la variable address del objeto location */
  getAddress() {
    /** Crea una instancia del geo-codificador */
    const geocoder = new google.maps.Geocoder();
    /** Crea un objeto de LatLng */
    const latlng = new google.maps.LatLng(this.location.lat, this.location.lng);
    /** Ejecuta la función de geo-codificación con el request */
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      // Si el status es diferente al OK de google, sale sin hacer nada
      if (status !== google.maps.GeocoderStatus.OK) { return; }
      // Muestra un mensaje de error si no pudo obtener la dirección
      if (results[0] === null) {
        this.errorMonitoringService.sendError('PERMISSION DENIED', 'getCurrentPosition');
        this.helperService.presentMessageAlert('No tenemos permiso', 'Danos permiso a la ubicación para mejorar los resultados');
        return;
      }
      // Obtiene la dirección para las coordenadas
      this.location.address = results[0].formatted_address;
    });
  }

  /** Carga el mapa con los datos de la variable location */
  loadMap() {
    this.heightMap = screen.height * 0.4;
    // div contenedor del mapa
    const mapContainer = document.getElementById('map');

    mapContainer.setAttribute('style', `height:${this.heightMap}px;`);
    // Api de Google https://developers.google.com/maps/documentation/javascript/reference
    this.map = new google.maps.Map(mapContainer);
    // Clase para instanciar la representación gráfica de coordenadas
    // https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngBounds
    this.bounds = new google.maps.LatLngBounds();
    // Objeto de opciones para crear el mapa y centrar https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
    this.mapOptions = {
      /** The initial Map center. Required. */
      center: { lat: this.location.lat, lng: this.location.lng },
      /** The initial Map zoom level. Required. Valid values: Integers between zero, and up to the supported maximum zoom level. */
      zoom: 17,
      /** The initial enabled/disabled state of the Map type control. */
      mapTypeControl: false,
      /** https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions.streetView */
      streetViewControl: false,
      /** The enabled/disabled state of the Fullscreen control. */
      fullscreenControl: false,
      /** The enabled/disabled state of the Zoom control. */
      zoomControl: true
    };

    /** https://developers.google.com/maps/documentation/javascript/reference/map#Map.setOptions */
    this.map.setOptions(this.mapOptions, error => {
      this.helperService.presentMessageAlert(error, 'Tu navegador no soporta geolocalización');
      return console.log('Geolocation is not supported by this Browser/OS and could not be rendering.');
    });

    // si se tiene que mostrar el rango
    if (this.showRange) {
      // Hace una marca por medio de un círculo https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerShape
      // this.circle = new google.maps.Circle({
      // Opciones de la interfaz del círculo
      // https://developers.google.com/maps/documentation/javascript/reference/polygon#CircleOptions
      //   strokeColor: '#00375d',
      //   strokeOpacity: 0.8,
      //   strokeWeight: 4,
      //   fillColor: '#00375d',
      //   fillOpacity: 0.35,
      //   map: this.map,
      //   center: this.map.getCenter(),
      //   radius: this.range,
      //   clickable: false
      // });
      // cuando empieza a hacerse drag. Manejo de eventos https://developers.google.com/maps/documentation/javascript/events
      this.map.addListener('dragstart', () => {
        // 3 seconds after the center of the map has changed, pan back to the
        // marker.
        // window.setTimeout(function() {
        //   map.panTo(marker.getPosition());
        // }, 3000);
        // this.circle.setMap(null);
      }, error => {
        this.errorMonitoringService.sendError(error, 'loadMap');
      });
      // cuando finaliza de hacerse drag
      this.map.addListener('dragend', () => {
        // this.circle.setMap(this.map);
      }, error => {
        this.errorMonitoringService.sendError(error, 'loadMap');
      });
    }

    // cada vez que el centro del mapa cambia guarda las coordenadas
    this.map.addListener('center_changed', () => {
      const latLng = this.map.getCenter();
      this.location.lat = latLng.lat();
      this.location.lng = latLng.lng();
      window.setTimeout(() => {
        // this.circle.setCenter({ lat: this.location.lat, lng: this.location.lng });
        this.getAddress();
      }, 10000);
    }, error => {
      this.errorMonitoringService.sendError(error, 'loadMap');
    });

    // cada vez que el zoom cambia guarda el nivel de zoom
    this.map.addListener('zoom_changed', () => {
      // this.zoomLevel = this.map.getZoom();
    }, error => {
      this.errorMonitoringService.sendError(error, 'loadMap');
    });
    this.mapsPlaces = new google.maps.places.PlacesService(this.map);
  }

  /* Actualiza los resultados de la búsqueda */
  public updateSearchResults() {
    if (this.sessionToken == null) { this.sessionToken = new google.maps.places.AutocompleteSessionToken(); }
    if (this.searchingAddress === '') { return this.suggestList = []; }
    this.autocompleteMap.getPlacePredictions({
      input: this.searchingAddress,
      bounds: this.map.getBounds(),
      sessionToken: this.sessionToken,
      componentRestrictions: { country: this.user.country }
    }, (predicciones, estado) => {
        this.suggestList = [];
        if (predicciones) {
          this.zone.run(() => {
            /** Alimenta el array que contiene las predicciones de dirección */
            predicciones.forEach(prediction => {
              this.suggestList.push(prediction);
            });
          });
        }
      }, error => {
        this.errorMonitoringService.sendError(error, 'updateSearchResults');
      }
    );
  }

  /** Acción de seleccionar un elemento de las predicciones de dirección */
  public selectSearchResult(sugerencia) {
    if (sugerencia === 'actual') {
      this.getCurrentPosition();
      this.location.title = '';
      this.newUserLocationSelected = true;
      return this.secondStep({ listSelected: this.location });
    }
    this.suggestList = [];
    // Obtiene los detalles de un lugar
    // https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesService.getDetails
    this.mapsPlaces.getDetails({
      placeId: sugerencia.place_id,
      // Información a obtener https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult
      fields: [
        'address_component', 'adr_address', 'alt_id', 'formatted_address',
        'geometry', 'icon', 'id', 'name', 'photos', 'place_id',
        'plus_code', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity'
      ],
      sessionToken: this.sessionToken
    }, (lugar, estado) => {
      if (estado === google.maps.places.PlacesServiceStatus.OK) {
        if (!lugar.geometry) {
          return this.helperService.presentMessageAlert('Mensaje', `No hay detalles disponibles para el lugar: ${lugar.name}`);
        }

        // si el lugar tiene una geometría, entonces mostrarlo en el mapa.
        if (lugar.geometry.viewport) {
          // Asigna las coordenadas para centrar el mapa
          // https://developers.google.com/maps/documentation/javascript/reference/map#Map.fitBounds
          this.map.fitBounds(lugar.geometry.viewport);
          this.location.lat = lugar.geometry.location.lat();
          this.location.lng = lugar.geometry.location.lng();
        } else {
          this.map.setCenter(lugar.geometry.location);
          this.map.setZoom(this.mapOptions.zoom);
        }
        this.newUserLocationSelected = true;

        this.location = {
          title: lugar.name ? lugar.name : '',
          address: lugar.formatted_address,
          addressComplement: '',
          lat: this.location.lat,
          lng: this.location.lng,
          user: this.user.uid
        };
        this.sessionToken = null;
      }
    }, error => {
      this.errorMonitoringService.sendError(error, 'selectSearchResult');
    });
    this.searchingAddress = '';
    this.secondStep({ listSelected: this.location });
  }

  /** guarda la dirección si es nueva */
  saveUserLocation() {
    // valida que la info este completa
    const validate = this.validateLocation();
    if (validate) {
      if (validate === 'title') { this.helperService.presentMessageAlert('Mensaje', 'Completa la etiqueta'); }
      /* if (validate === 'location') { this.helperService.presentMessageAlert('Mensaje', 'Selecciona una ubicación'); } */
      if (validate === 'address') { this.helperService.presentMessageAlert('Mensaje', 'Completa la dirección'); }
      return;
    }

    // guarda la location
    if (this.newUserLocationSelected && this.user) {
      this.savingLocation = true;
      // Guarda la ubicación
      this.servicesService.addUserLocation(this.location).then(async (userLocationRef) => {
        this.newUserLocationSelected = false;
        this.userLocations.forEach(location => {
          if (location.id === userLocationRef.id) {
            this.modalController.dismiss(location);
          }
        });
        this.savingLocation = false;
      }).catch(error => {
        this.savingLocation = false;
        this.helperService.presentMessageAlert('Mensaje', `No fue posible agregar la ubicación, inténtalo de nuevo`);
        this.errorMonitoringService.sendError(error, 'addUserLocation');
      });
    }
  }

  /** Valida si la ubicación esta completamente llena */
  validateLocation() {
    /* if (!this.location.lat || !this.location.lng) { return 'location'; } */
    if (!this.location.title) { return 'title'; }
    if (!this.location.address) { return 'address'; }
  }

  /** Elimina una ubicación guardada por el cliente */
  async removeLocation(location): Promise<void> {
    const alert = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-medium',
      componentProps: {
        icon: 'alerta',
        title: `Alerta`,
        subtitle : 'La ubicación se borrara de manera permanente ¿Deseas continuar?',
        buttons: [
          {
            text: 'Cancelar',
            fill: 'clear',
            color: 'danger',
            action: ''
          },
          {
            text: 'Borrar',
            fill: 'solid',
            color: 'primary',
            action: 'delete'
          },
        ]
      },
      backdropDismiss: false
    });
    alert.onDidDismiss().then(data => {
      if (data.data.action === 'delete') {
        this.servicesService.deleteUserLocation(location.id).catch( error => {
          this.helperService.presentMessageAlert('Mensaje', 'No pudimos eliminar la ubicación, inténtalo de nuevo');
          this.errorMonitoringService.sendError(error, 'deleteUserLocation');
        });
      }

    });
    return await alert.present();
  }

  /** Cierra el modal enviando datos a la página solicitante */
  closeMap(): void {
    this.modalController.dismiss();
  }

  /** Realiza el cambio de paso */
  secondStep({ listSelected, close = false }: { listSelected: any; close?: boolean; }) {
    /** Cuando se solicita cerrar el modal */
    if (close) { return this.modalController.dismiss(listSelected); }
    this.stepNumber = 1;
    this.loadMap();
  }

  /** Retorna un paso */
  firstStep() {
    this.stepNumber = 0;
    /* this.getCurrentPosition(); */
  }
}
